module.exports = __webpack_public_path__ + "img/suitHolder03.efcc9663.jpg";